// src/components/Integrations/WhatsAppOAuthCallback.jsx
import { useEffect, useState } from 'react';
import MetaService from '../../services/meta.service';
import Spinner from '../Spinner';

const WhatsAppOAuthCallback = () => {
  const [status, setStatus] = useState('processing'); // 'processing' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const handleOAuthCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');

      if (error) {
        setStatus('error');
        setErrorMsg(error);
        window.opener?.postMessage({ type: 'OAUTH_ERROR', error }, window.location.origin);
        setTimeout(() => window.close(), 2000);
        return;
      }

      if (!code || !state) {
        setStatus('error');
        setErrorMsg('No authorization code received from Meta.');
        window.opener?.postMessage(
          { type: 'OAUTH_ERROR', error: 'No authorization code received' },
          window.location.origin
        );
        setTimeout(() => window.close(), 2000);
        return;
      }

      // Leer datos guardados antes de abrir el popup
      const accountId = sessionStorage.getItem('meta_signup_account_id');
      const wabaId = sessionStorage.getItem('meta_signup_waba_id');
      const phoneNumberId = sessionStorage.getItem('meta_signup_phone_number_id');
      sessionStorage.removeItem('meta_signup_account_id');
      sessionStorage.removeItem('meta_signup_waba_id');
      sessionStorage.removeItem('meta_signup_phone_number_id');

      if (!accountId) {
        setStatus('error');
        setErrorMsg('Session expired. Please try connecting again.');
        window.opener?.postMessage(
          { type: 'OAUTH_ERROR', error: 'Missing account session' },
          window.location.origin
        );
        setTimeout(() => window.close(), 2000);
        return;
      }

      try {
        const result = await MetaService.processCallback({
          id: accountId,
          authorizationCode: code,
          state,
          wabaId: wabaId || undefined,
          phoneNumberId: phoneNumberId || undefined
        });

        if (result.success) {
          setStatus('success');
          window.opener?.postMessage(
            { type: 'META_OAUTH_CALLBACK', success: true },
            window.location.origin
          );
        } else {
          const msg = result.error?.message || 'Error processing Meta authorization.';
          setStatus('error');
          setErrorMsg(msg);
          window.opener?.postMessage({ type: 'OAUTH_ERROR', error: msg }, window.location.origin);
        }
      } catch (err) {
        const msg = err.message || 'Unexpected error during authorization.';
        setStatus('error');
        setErrorMsg(msg);
        window.opener?.postMessage({ type: 'OAUTH_ERROR', error: msg }, window.location.origin);
      }

      setTimeout(() => window.close(), 1500);
    };

    handleOAuthCallback();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg text-center max-w-md">
        {status === 'processing' && (
          <>
            <div className="flex justify-center mb-4">
              <Spinner size="xl" color="green" />
            </div>
            <h2 className="text-white text-lg font-medium mb-2">Connecting WhatsApp...</h2>
            <p className="text-gray-400 text-sm">Processing authorization. This window will close automatically.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-white text-lg font-medium mb-2">WhatsApp Connected!</h2>
            <p className="text-gray-400 text-sm">Your WhatsApp Business account has been connected successfully.</p>
            <p className="text-gray-500 text-xs mt-3">This window will close automatically...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-5xl mb-4">❌</div>
            <h2 className="text-white text-lg font-medium mb-2">Connection Failed</h2>
            <p className="text-red-400 text-sm">{errorMsg}</p>
            <p className="text-gray-500 text-xs mt-3">This window will close automatically...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default WhatsAppOAuthCallback;
